module.exports = __webpack_public_path__ + "static/media/card2.876587ff.jpg";